import api from './api';

export const equipmentMaintenanceApi = {
  getAll: async (params = {}) => {
    const response = await api.get('/equipment-maintenance', { params });
    return response.data;
  },
  
  getById: async (id: number) => {
    const response = await api.get(`/equipment-maintenance/${id}`);
    return response.data;
  },
  
  create: async (data: any) => {
    const response = await api.post('/equipment-maintenance', data);
    return response.data;
  },
  
  update: async (id: number, data: any) => {
    const response = await api.put(`/equipment-maintenance/${id}`, data);
    return response.data;
  },
  
  delete: async (id: number) => {
    const response = await api.delete(`/equipment-maintenance/${id}`);
    return response.data;
  },
};